import { useRoute } from '#imports'

import { useIsWebviewUserAgent } from './useIsWebviewUserAgent'

export function useIsWebview() {
  const route = useRoute()

  return Boolean(route.meta?.isWebview) || useIsWebviewUserAgent()
}
